<template>
    <div>
        <b-card v-if="isLoaded && selectedSite">
            <b-row align-h="between" style="text-align: center">
                <b-col cols="6" class="mb-4" style="display: flex; justify-content: flex-start; height: 40px;">
                    <div @click="routeToDashboard(selectedSite.id, year)" style="font-weight: bold; font-size: 1.2em; align-self: center; cursor: pointer">{{selectedSite.name}} - {{ $t('title') }}</div>
                </b-col>
                <b-col cols="6" sm="9" md="7" lg="5" xl="6">
                    <b-row align-h="end" style="height: 40px">
                        <year-select @onchange="onYearChange"/>
                        <site-multi-select
                            :selectedSiteId="selectedSite.id"
                            :givenSites="filteredSites"
                            :allowEmpty="true"
                            @oninput="selectSiteId"/>
                    </b-row>
                </b-col>
            </b-row>
            <div style="margin-top: 50px">
                <!-- new add folder part -->
            <b-modal ref="documentModal" @hide="onModalHide" size="sm" hide-footer hide-header centered>
            <div class="d-block text-center">
                <b-row align-h="start">
                    <b-col style="font-weight: bold; text-align: left">
                        {{$t('folder')}}
                    </b-col>
                </b-row>
                <b-row class="mt-1">
                    <b-col v-if="isSupervisor">
                        <b-form-select cols="6" v-model="selectedFolderId">
                            <option :value="null">{{ $t('new') }}</option>
                            <option v-for="folder in folders" :key="'agentOptions'+ folder.id" :value="folder.id">{{ folder.name }}</option>
                        </b-form-select>
                    </b-col>
                    <b-col v-else>
                        <b-form-select cols="6" v-model="selectedExistingFolderId">
                            <option :value="null" disabled >Bir klasör seçin</option>
                            <option v-for="folder in folders" :key="'supervisorOptions'+ folder.id" :value="folder.id">{{ folder.name }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row v-if="!selectedFolderId && isSupervisor" align-h="start" class="mt-3">
                    <b-col style="font-weight: bold; text-align: left">
                        {{$t('folderName')}}
                    </b-col>
                </b-row>
                <b-row v-if="!selectedFolderId && isSupervisor" class="mt-1">
                    <b-col>
                        <b-form-input v-model="folderName"/>
                    </b-col>
                </b-row>
                <b-row align-h="start" class="mt-3">
                    <b-col v-if="uploadedFile" style="text-align: start">
                        <upload 
                            :showUpload="false" 
                            :showDownload="false" 
                            :reactive-id="reactiveId"
                            :deleteFromDB="true"
                            :dataId="uploadedFile.id"
                            @onremove="handleRemoving"/>
                        <div style="font-size: 12px;">{{uploadedFile.filename | textToShortText}}</div>
                    </b-col>
                    <b-col v-else style="text-align: start">
                        <upload-regular 
                            @onupload="onupload"/>
                    </b-col>
                </b-row>
                <b-row v-if="uploadedFile" align-h="start" class="mt-3">
                    <b-col style="font-weight: bold; text-align: left">
                        {{$t('documentDate')}}
                    </b-col>
                </b-row>
                <b-row v-if="uploadedFile" class="mt-1">
                    <b-col>
                        <template v-if="this.gbId(this.$store.state.user.customerId)">
                            <el-date-picker
                                v-model="fileDate"
                                type="year"
                                :placeholder="$t('chooseDatePlaceholder')"/>
                        </template>
                        <template v-else>
                            <el-date-picker
                            v-model="fileDate"
                            type="month"
                            :placeholder="$t('chooseDatePlaceholder')"/>
                        </template>
                    </b-col>
                </b-row>
            </div>
            <b-row align-h="end">
                <b-col cols="6">
                    <b-btn size="sm" class="mt-3" variant="outline-primary" block @click="createDoc()">{{$t('save')}}</b-btn>
                </b-col>
            </b-row>
        </b-modal>
        <b-row align-h="between">
            <b-col style="font-weight: bold; text-align: start;">
                <span style="text-align: center; font-size: 22px">
                    {{ $t('title') }}
                </span>
            </b-col>
            <b-col v-show="this.$store.state.user.permissions.canUploadDocuments" cols="2" style="font-weight: bold; text-align: end;">
                <b-btn @click="$refs.documentModal.show()">{{ $t('Upload File') }}</b-btn>
            </b-col>
        </b-row>
            <b-modal ref="folderEdit" size="sm" hide-footer hide-header centered>
                <div class="d-block text-center">
                    <b-row align-h="start" class="mt-3">
                        <b-col style="font-weight: bold; text-align: left">
                            {{$t('newFolderName')}}
                        </b-col>
                    </b-row>
                    <b-row class="mt-1">
                        <b-col>
                            <b-form-input
                                v-model="folderEditedName"
                                :state="folderNameState"
                                aria-describedby="input-live-help input-live-feedback"
                                trim    
                            />
                            <div style="height: 15px">
                               <p v-if="!folderNameState" class="mt-1 mb-0" style="color : red">{{$t('folderNameValidationFeedback')}}</p>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row align-h="end">
                        <b-col cols="6">
                            <b-btn size="sm" class="mt-3" variant="outline-primary" block @click="editFolder(folderEditedName)">{{$t('save')}}</b-btn>
                        </b-col>
                    </b-row>
                </div>
            </b-modal>
            <b-modal ref="confirmFolderDelete" size="sm" hide-footer hide-header centered>
                <div class="d-block text-center">
                    <b-row align-h="start" class="mt-3" style="margin-bottom: 10px">
                        <b-col style="font-weight: bold; text-align: left">
                            {{$t('confirm')}}
                        </b-col>
                    </b-row>
                    <b-row align-h="end">
                        <b-col cols="2">
                            <b-button style="margin-right:10px" size="sm" @click="deleteFolder(true)" variant="danger">{{$t('yes')}}</b-button>
                        </b-col>
                        <b-col cols="6">
                            <b-button style="margin-right:10px" size="sm" @click="deleteFolder(false)" variant="secondary">{{$t('no')}}</b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-modal>
            <b-row v-for="(doc,index) in otherDocs" :key="index" style="margin-top: 5px">
                <b-card-header header-tag="div" class="p-1" style="width: 100%">
                    <b-btn block variant="info" @click="$root.$emit('bv::toggle::collapse', String(doc.id));">{{doc.name}}</b-btn>
                </b-card-header>
                <b-collapse :id="String(doc.id)" accordion="my-accordion" role="tabpanel">
                    <div class="edit-column">
                                <b-row>
                                    <b-button v-if="isSupervisor" style="margin-right:10px" size="sm" @click="openFolderEditModal(doc.id)" variant="info"><i class="fas fa-edit"></i></b-button>
                                    <b-button v-if="isSupervisor" style="margin-right:10px" size="sm" @click="openFolderDeleteModal(doc.id)" variant="info"><i class="fas fa-trash-alt"></i></b-button>
                                </b-row>   
                    </div>
                    <b-card-body>
                        <div class="table-responsive mt-3">
                            <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em">
                                <thead>
                                <tr >
                                    <th class="col-3">{{ $t('docColumn') }}</th>
                                    <th class="col-3">{{ $t('uploadingDate') }}</th>
                                    <th class="col-3" >{{ $t('fileDate') }}</th>
                                    <th class="col-3">{{ $t('operation') }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="siteDocument in doc.documents">
                                    <td>
                                        <div class="tableBodyCell">
                                            <span @click="downloadFile(siteDocument.fileUrl)" class="link-basic">{{siteDocument.filename}}</span>
                                            <!-- <a :href="`${apiURL}/upload/${siteDocument.uuid}`" target="_blank">{{siteDocument.filename}}</a> -->
                                        </div>
                                    </td>
                                    <td>
                                        <div class="tableBodyCell">
                                            {{ siteDocument.createdAt | formatDate('YYYY-MM-DD')}}
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="siteDocument.fileDate" class="tableBodyCell">
                                            <template v-if="gbId($store.state.user.customerId)">
                                                {{siteDocument.fileDate | formatDate('YYYY')}}
                                            </template>
                                            <template v-else>
                                                {{siteDocument.fileDate | formatDate('MM/YYYY')}}
                                            </template>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="tableBodyCell">
                                            <b-button style="margin-right:80px; margin-left:80px;" size="sm" v-b-modal.warn v-b-tooltip.hover :title="$t('delete')" @click="deleteDocument($event, siteDocument.uuid)" variant="danger"><i class="fas fa-trash-alt"></i></b-button>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-card-body>
                </b-collapse>
            </b-row>
        </div>
        </b-card>
        <div v-else></div>
    </div>
</template>

<script>
import _ from 'lodash';
import qs from 'qs';
import Multiselect from 'vue-multiselect';
import SiteCard from '../../../components/SiteCard';
import UploadRegular from '../../../components/UploadRegular';
import SiteMultiSelect from '../../../components/SiteMultiSelect';
import YearSelect from '../../../components/YearSelect';
import uuid from 'uuid/v4';
import Upload from '../../../components/Upload';

export default {
    components: {
        YearSelect,
        SiteMultiSelect,
        UploadRegular,
        SiteCard,
        Multiselect,
        Upload
    },
    name: 'FileDetail',
    data() {
        return {
            isLoaded: false,
            selectedSite: null,
            selectedFolderId: null,
            selectedExistingFolderId: null,
            siteDocuments: [],
            filteredSites: [],
            folderName: null,
            selectedFolderIdToEdit: null,
            folderEditedName: "",
            docs: [],
            otherDocs: [],
            folders: [],
            uploadedFile: null,
            reactiveId: uuid(),
            fileDate: null,
        };
    },
    methods: {
        resetDoc() {
            this.uploadedFile = null;
            this.folderName = null;
            this.selectedFolderId = null;
        },
        createDoc() {
            let payload = {
                file: this.uploadedFile,
                folderName: this.folderName,
                folderId: this.selectedFolderId
                    ? this.selectedFolderId
                    : this.selectedExistingFolderId,
                siteId: this.selectedSite.id,
                documentDate: this.fileDate,
                type: 'other'
            };
            if (!payload.file && payload.folderId) {
                this.$toasted.error(this.$t('missingDocument'));
            } else if (
                (!payload.documentDate && payload.file) ||
                (!payload.folderName && !payload.folderId)
            ) {
                this.$toasted.error(this.$t('missingError'));
            } else {
                this.$Progress.start();
                return this.axios
                    .post('/folders', payload)
                    .then(({data}) => {
                        this.$Progress.finish();
                        if (this.selectedFolderId) {
                            this.otherDocs.forEach((doc, index) => {
                                if (doc.id === this.selectedFolderId) {
                                    data.document.siteId == this.selectedSite.id
                                        ? this.otherDocs[index].documents.push(data.document)
                                        : this.$Progress.finish();
                                }
                            });
                        }
                        if (data.document) {
                            this.folders.push(JSON.parse(JSON.stringify(data.folder)));
                            data.folder.documents = [data.document];
                            this.otherDocs.push(data.folder);
                        } else {
                            let newFolder = {};
                            newFolder.id = data.id;
                            newFolder.name = data.name;
                            this.folders.push(JSON.parse(JSON.stringify(newFolder)));
                        }
                        this.$refs.documentModal.hide();
                        this.getSiteDocs();
                        this.resetDoc();
                    })
                    .catch(err => {
                        this.$toasted.error(this.$t(err.response.data.message));
                        this.$Progress.finish();
                        this.resetDoc();
                    });
            }
        },
        routeTo(site) {
            this.$router.push({
                name: 'site-files',
                params: {site_id: site ? site.id : this.route.params.site_id},
                query: {year: this.year}
            });
            return Promise.resolve();
        },
        init() {
            let promiseArr = [this.getSiteDocs(), this.getFolders()];
            this.$Progress.start();
            return Promise.all(promiseArr).then(() => {
                this.isLoaded = true;
                this.$Progress.finish();
            });
        },
        deleteDocument(event, id) {
            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, () => {
                this.axios
                    .delete(`/documents/${id}`)
                    .then(() => {
                        this.siteDocuments = this.siteDocuments.filter(item => {
                            return item.uuid !== id;
                        });
                        this.getSiteDocs();
                    })
                    .catch(() => {
                        this.showErrorNotification(
                            'Silme işlemi gerçekleştirilemedi, tekrar deneyin.'
                        );
                    });
            });
        },
        openFolderEditModal(id) {
            this.selectedFolderIdToEdit = id;
            this.folderEditedName = _.find(this.folders, function(o) {
                return o.id === id;
            }).name;
            this.$refs.folderEdit.show();
        },
        openFolderDeleteModal(id) {
            this.selectedFolderIdToEdit = id;
            this.$refs.confirmFolderDelete.show();
        },
        editFolder(folderName) {
            if(this.folderEditedName !== ""){
                let folderId = this.selectedFolderIdToEdit;
                this.$refs.folderEdit.show();
                let payload = {
                    id: folderId,
                    folderName: folderName
                };
                this.$Progress.start();
                return this.axios.put('/folders', payload).then(() => {
                    this.$Progress.finish();
                    this.init().then(() => {
                        this.$refs.folderEdit.hide();
                        this.folderEditedName = null;
                    });
                });
            }
        },
        deleteFolder(bool) {
            let folderId = this.selectedFolderIdToEdit;
            if (bool) {
                let currentFolderDocs = _.find(this.otherDocs, function(o) {
                    return o.id === folderId;
                }).allDocuments;
                if (_.isEmpty(currentFolderDocs)) {
                    this.$Progress.start();
                    return this.axios.delete(`/folders/${folderId}`).then(() => {
                        this.$Progress.finish();
                        this.init();
                        this.$refs.confirmFolderDelete.hide();
                    }).catch(()=>{
                        this.$Progress.finish();
                        this.$refs.confirmFolderDelete.hide();
                        this.$notify({
                            group: 'info',
                            title: this.$t('went-wrong'),
                            text: this.$t('document-exist'),
                            type: 'error'
                        });
                    });
                } else {
                    this.$toasted.error(this.$t('folderDeletionError'));
                    this.$refs.confirmFolderDelete.hide();
                }
            } else {
                this.$refs.confirmFolderDelete.hide();
            }
        },
        handleRemoving() {
            this.uploadedFile = null;
        },
        selectSiteId(site) {
            if (!site) {
                this.$router.push({name: 'doc', query: {year: this.year}});
            } else {
                this.selectedSite = site;
                this.$store.state.siteId = site ? site.id : null;
                return this.routeTo(site);
                //return this.getSiteDocs();
            }
        },
        onYearChange(newYear) {
            this.$store.state.year = newYear;
            return this.getSiteDocs().then(this.routeTo);
        },
        getSiteDocs() {
            this.$Progress.start();
            return this.axios
                .get(
                    `${this.route.params.site_id}/files/others?${qs.stringify({
                        start_date: this.year
                    })}`
                )

                .then(({data}) => {
                    // hid folders with empty name
                    this.otherDocs = _.filter(data, folder => _.get(folder, 'name') != null);
                    this.$Progress.finish();
                });
        },
        getFolders() {
            return this.axios
                .get('/folders', {
                    params: {
                        folder_type: this.otherFolderTypes
                    }
                })
                .then(({data}) => {
                    // hid folders with empty name
                    this.folders = _.filter(data, folder => _.get(folder, 'name') != null);
                });
        },
        onupload(event) {
            this.uploadedFile = {
                id: event.id,
                filename: event.filename,
                uuid: event.fileId,
                fileUrl: event.fileUrl,
                onCloud: event.onCloud
            };
        },
        onModalHide(event){
            if(this.uploadedFile && _.get(event, 'trigger') == 'backdrop' && this.uploadedFile.onCloud){
                this.axios.delete(`/deleteFromAws/${this.uploadedFile.id}`)
                    .then(()=>{this.uploadedFile = null});
            }
            
        }
    },
    watch: {
        'route.query': {
            handler: 'init',
            immediate: true
        }
    },
    computed: {
        isSupervisor() {
            return this.$store.state.user.permissions.canStartAudits;
        },
        folderNameState() {
            if(this.folderEditedName){
                return this.folderEditedName.length > 0 && this.folderEditedName !== " " ? true : false
            }
            return null;
        }
    },
    created() {
        this.$store.state.year = this.route.query.year ? Number(this.route.query.year) : this.year;
        this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
        this.selectedSite = _.find(this.sites, {id: Number(this.route.params.site_id)});
        this.filteredSites = this.sites;
        this.isLoaded = false;
    }
};
</script>

<style lang="scss">
.tab-deactive {
    .nav-link {
        background-color: #ddd;
    }
}
.table-button-delete {
    background-color: white;
    height: inherit;
    display: flex;
    justify-content: center;
    button {
        color: rgba(136, 136, 136, 0.53);
        background-color: white;
        border-color: white;
    }
}
</style>

<i18n src="../../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "title": "BELGELER",
            "docColumn": "Doküman",
            "uploadingDate": "Yüklenme Tarihi",
            "fileYear": "Dosya yılı",
            "fileDate": "Dosya tarihi",
            "operation": "İşlem",
            "folderOperation": "Lütfen bir klasör işlemi seçin",
            "folder": "Klasör",
            "folderName": "Klasör Adı",
            "newFolderName": "Yeni Klasör Adı",
            "documentYear": "Doküman Yılı",
            "documentDate": "Doküman Tarihi",
            "confirm": "Klasörü silmek istediğinize emin misiniz?",
            "folderNameValidationFeedback" : "Klasör adı boş bırakılamaz"
        },
        "en": {
            "title": "DOCUMENTS",
            "docColumn": "Document",
            "uploadingDate": "Uploading Date",
            "fileYear": "File year",
            "fileDate": "File date",
            "operation": "Operation",
            "folderOperation": "Please select an operation of folder",
            "folder": "Folder",
            "folderName": "Folder Name",
            "newFolderName": "New Folder Name",
            "documentYear": "Document Year",
            "documentDate": "Document Date",
            "confirm": "Are you sure to delete this folder?",
            "folderNameValidationFeedback" : "Folder name can not be left blank"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Doc/Files/Detail.vue